import { MessageCircle, X } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import LiveWidget from './LiveWidget';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const navItems = [
    { name: 'Beranda', path: '/' },
    { name: 'Tentang Kami', path: '/about' },
    { name: 'Panduan', path: '/services' },
    { name: 'Artikel', path: '/artikel-kenzie-komunika' },
    { name: 'Kontak', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  const [open, setOpen] = useState(false);

  return (
    <>
    <nav className={`fixed w-full z-50 transition-all duration-500 ${
      scrolled 
        ? 'bg-slate-100/95 backdrop-blur-lg shadow-lg shadow-blue-500/10' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 group cursor-pointer">
            <div className="flex items-center">
              <div className="flex transform group-hover:scale-120 ">
                <img src="/images/logo.png" alt="Kenzie Logo" className="h-12 w-auto flex group-hover:animate-softPulse" />
              </div>
            </div>
          </Link>

          {/* Desktop Menu */}
          <ul className="hidden md:flex space-x-1">
            {navItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={`px-4 py-2 rounded-full transition-all duration-300 relative group ${
                    isActive(item.path)
                      ? 'bg-gradient-to-br from-red-500 to-[#3E3274] text-white'
                      : 'hover:bg-gradient-to-r hover:from-red-600/20 hover:to-[#3E3274]/20'
                  } ${scrolled  ? 'text-black' : 'text-white'}`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* CTA Button */}
          <Link 
            to="https://kenziekomunika.webreport.info/" target="_blank"
            className="hidden text-white md:block px-6 py-2.5 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold hover:shadow-lg hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
          >
            Web Report
          </Link>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden bg-white p-2 mr-4 rounded-lg hover:bg-slate-800 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden transition-all duration-300 overflow-hidden ${
        isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <ul className="px-4 pt-2 pb-4 space-y-2 bg-slate-100/95 backdrop-blur-lg">
          {navItems.map((item, index) => (
            <>
              <li key={index}>
                <Link
                  to={item.path}
                  className={`block px-4 py-2 rounded-full transition-all duration-300 ${
                    isActive(item.path)
                      ? 'bg-gradient-to-br from-red-500 to-[#3E3274] text-white'
                      : 'hover:bg-gradient-to-r hover:from-red-600/20 hover:to-[#3E3274]/20'
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            </>
          ))}
          <li>
            <Link 
              to="https://kenziekomunika.webreport.info/" target="_blank"
              className="text-white md:block px-6 py-2.5 bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold hover:shadow-lg hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
            >
              Web Report
            </Link>
          </li>
        </ul>
      </div>
    </nav>
    <div className="fixed bottom-6 left-6 z-50">
      {open && (
        <div className="mb-4 w-72 bg-white rounded-2xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
          <div className="bg-green-500 text-white p-4">
            <h3 className="font-semibold text-lg">Butuh Bantuan?</h3>
            <p className="text-sm opacity-90">
              Chat kami langsung via WhatsApp
            </p>
          </div>

          <div className="p-4">
            <a
              href="https://wa.me/628987897555"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-xl transition"
            >
              <FaWhatsapp size={18} />
              Chat Sekarang
            </a>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-xl transition-all duration-300 hover:scale-110"
      >
        {open ? <X size={22} /> : <FaWhatsapp size={26} />}
      </button>
      <LiveWidget/>
    </div>
    </>
  );
}
